import { createAction } from 'typesafe-actions';

import { Coworking } from 'shared/types/filters/geo';

export const changeCoworkingAction = createAction('filters/coworkingChanged')<Coworking>();
